import { type ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  gradient?: boolean
}

export function Card({ children, className = '', gradient = false }: CardProps) {
  return (
    <div className={`bg-[var(--color-surface)] rounded-2xl border border-[var(--color-border)] overflow-hidden shadow-sm ${className}`}>
      {gradient && (
        <div className="h-2 bg-gradient-to-r from-[var(--color-secondary)] to-[var(--color-primary)]" />
      )}
      <div className="p-5">
        {children}
      </div>
    </div>
  )
}

interface CardRowProps {
  label: string
  value: string
  highlight?: boolean
  mono?: boolean
}

export function CardRow({ label, value, highlight = false, mono = false }: CardRowProps) {
  return (
    <div className="flex justify-between">
      <span className={`text-sm ${highlight ? 'font-medium text-[var(--color-secondary)]' : 'text-[var(--color-text-muted)]'}`}>
        {label}
      </span>
      <span className={`text-sm font-medium text-[var(--color-text)] ${mono ? 'font-mono' : ''}`}>
        {value}
      </span>
    </div>
  )
}

export function CardDivider({ dashed = false }: { dashed?: boolean }) {
  return <hr className={`border-[var(--color-border)] my-4 ${dashed ? 'border-dashed' : ''}`} />
}
